/* eslint-disable react/no-danger */
import { GridColDef } from "@mui/x-data-grid-pro";
import {
  Divider,
  GKButton,
  GKClientDataGrid,
  Grid2,
  PlusIcon,
  Typography,
} from "components";
import { useFetchQuery } from "hooks/useQueries";
import { useState } from "react";
import { extraColumnsField, htmlToText } from "utils/helpers";
import useDocumentTitle from "utils/useDocumentTitle";
import DigioDetails from "./DigioDetails";
import EstampModal from "./EstampModal";

const Digio = () => {
  useDocumentTitle("Digio");

  const [showSheetModal, setShowSheetModal] = useState(false);

  const [selectedRow, setSelectedRow] = useState<any>(null);

  const { data: estampTags } = useFetchQuery({
    key: ["ESTAMP_TAGS_QUERY_KEY"],
    route: "/estamp-tags/",
  });

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("Tag", "tags", 0, 1),
    },
    {
      ...extraColumnsField("Description", "description", 0, 1),
      valueGetter: (params) => htmlToText(params?.row?.description),
    },
  ];

  const handleRowClick = (params: any) => {
    setSelectedRow(params.row);
    setShowSheetModal(true);
  };

  return (
    <>
      <Grid2 container spacing={2}>
        <Grid2 size={3}>
          <Typography
            fontSize={16}
            fontWeight={500}
            color={"var(--neutral-500)"}
          >
            Setup
          </Typography>
        </Grid2>
        <Grid2 size={9}>
          <DigioDetails />
        </Grid2>
        <Grid2 size={12}>
          <Divider />
        </Grid2>
        <Grid2 size={3}>
          <Typography
            fontSize={16}
            fontWeight={500}
            color={"var(--neutral-500)"}
          >
            Estamp
          </Typography>
        </Grid2>
        <Grid2 size={9}>
          <GKClientDataGrid
            name="digio"
            columns={columns}
            rows={estampTags?.data?.data || []}
            onRowClick={handleRowClick}
            density="compact"
            headerComponent={
              <GKButton
                onClick={() => {
                  setSelectedRow(null);
                  setShowSheetModal(true);
                }}
                variant="contained"
                size="small"
                startIcon={<PlusIcon width={18} />}
              >
                Add Estamp
              </GKButton>
            }
          />
        </Grid2>
      </Grid2>
      {showSheetModal && (
        <EstampModal
          open={showSheetModal}
          setOpen={setShowSheetModal}
          sheetDetails={selectedRow}
        />
      )}
    </>
  );
};

export default Digio;
